var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":_vm.isDark}},[_c('Toolbar'),_c('v-content',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }